// Remembers an explicit sign-out for a few seconds.
//
// Firebase Auth can hand a session back moments after signOut(). A token
// refresh that was already in flight re-persists the user when it resolves
// (auth._persistUserIfCurrent queues behind the sign-out, then notifies
// listeners), and another tab that refreshes its token before its IndexedDB
// poll notices the sign-out writes the user back for every tab. Either way
// onAuthStateChanged fires with the old user and App.vue would bootstrap the
// session and bounce the login page back into the portal.
//
// Inside this window a user that appears is that echo, not a sign-in, and the
// auth listener in authBootstrap.js signs out again before any bootstrap work
// can refresh the token and write it back. The sign-in pages clear the mark
// before they authenticate so a deliberate sign-in on this tab is never
// mistaken for it. Seen in production on 2026-09-18 with two portal tabs open.
const KEY = 'renedian_signed_out_at'
const WINDOW_MS = 10000

export function markSignedOut() {
  try { sessionStorage.setItem(KEY, String(Date.now())) } catch (e) { /* private mode */ }
}

export function clearSignedOutMark() {
  try { sessionStorage.removeItem(KEY) } catch (e) { /* private mode */ }
}

export function recentlySignedOut() {
  try {
    const at = Number(sessionStorage.getItem(KEY) || 0)
    return at > 0 && Date.now() - at < WINDOW_MS
  } catch (e) {
    return false
  }
}
